<script>
  import {Line} from 'vue-chartjs'
  export default Line.extend({
    data () {
      return {
        datacollection: {
          datasets: [
            {
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
              pointBackgroundColor: 'white',
              pointBorderColor: '#fff',
              pointRadius: 4,
              pointHoverRadius: 6,
              pointHitRadius: 7,
              pointBorderWidth: 2,
              borderColor: '#65f289'
            }
          ]
        },
        options: {
          tooltips: {
            backgroundColor: '#FFF',
            titleFontSize: 16,
            titleFontColor: '#000',
            bodyFontColor: '#000',
            bodyFontSize: 16,
            displayColors: false
          },
          scales: {
            yAxes: [{
              ticks: {
                fontColor: '#fff',
                fontSize: 16,
                autoSkip: true,
                maxTicksLimit: 10,
                padding: 25
              },
              gridLines: {
                display: true,
                color: 'rgba(255,255,255,0.15)',
                drawBorder: false,
                zeroLineColor: 'rgba(255,255,255,0.15)',
                tickMarkLength: -5,
                lineWidth: 1
              }
            }],
            xAxes: [ {
              ticks: {
                beginAtZero: true,
                fontColor: '#fff',
                fontSize: 16,
                autoSkip: true,
                maxTicksLimit: 7,
                maxRotation: 0
              },
              gridLines: {
                display: false
              }
            }]
          },
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    props: {
      fetchData: {
        type: Object,
        default: function () {
          return []
        }
      },
      chartPeriod: {
        type: String,
        required: true
      }

    },
    watch: {
      chartPeriod: function (val) {
        this._chart.destroy()
        this.createChart(val)
      },
      fetchData: function (val) {
        this._chart.destroy()
        this.createChart('day')
      }
    },
    mounted () {
      this.createChart(this.chartPeriod)
    },
    methods: {
      createChart: function (val) {
        this.getChart(val)
        this.renderChart(this.datacollection, this.options)
      },
      getChart: function (arg) {
        this.getLabels(arg)
        this.getData(arg)
      },
      getLabels: function (arg) {
        let labels
        if (arg === 'day') {
          if (this.fetchData['day']) {
            labels = this.fetchData['day'].map(function (num, index, arr) {
            // console.log(new Date(num.timestamp))
              let h = new Date(num.timestamp * 1000).getHours()
              let m = new Date(num.timestamp * 1000).getMinutes()
              h = (h < 10) ? '0' + h : h
              m = (m < 10) ? '0' + m : m
              return h + ':' + m
            })
          }
        }
        if (arg === 'week') {
          let days = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
          labels = this.fetchData['week'].map(function (num, index, arr) {
            // console.log(new Date(num.timestamp))
            let n = new Date(num.timestamp * 1000).getDay()
            return days[n]
          })
        }
        this.datacollection.labels = labels
      },
      getData: function (arg) {
        // console.log(this.fetchData)
        let data
        if (arg === 'day') {
          if (this.fetchData['day']) {
            data = this.fetchData['day'].map(function (num, index, arr) {
              let rounded = function (number) {
                return +number.toFixed(2)
              }
              return rounded(num.particulate_matter)
            })
          }
        }
        if (arg === 'week') {
          data = this.fetchData['week'].map(function (num, index, arr) {
            let rounded = function (number) {
              return +number.toFixed(2)
            }
            return rounded(num.particulate_matter)
          })
        }
        this.datacollection['datasets'][0].data = data
      }
    }
  })
</script>



// WEBPACK FOOTER //
// LineChart.vue?26612a02